import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import DatumNavbar from './navbar'
import DatumSidebar from './sidebar'
import './datum.css'

const DatumLayout = ({ title, children }) => {
  useEffect(() => {
    document.title = title ? `${title} - Datum Insights` : 'Datum Insights'
  }, [title])

  return (
    <div style={{ backgroundColor: '#ffffff' }}>
      <ToastContainer />
      <DatumNavbar />
      <DatumSidebar />
      <main className="datum-main" role="main">
        {children}
      </main>
    </div>
  )
}

DatumLayout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default DatumLayout
